import React, { useState } from 'react';

import Paper from '@material-ui/core/Paper';

import DetailsPanel from './DetailsPanel';
import BuilderPanel from './BuilderPanel';

import * as classes from './ConversionPanel.module.css';

const ConversionPanel = ({
    ...props
}) => {
    const [newConversion, setNewConversion] = useState(false);

    return (
        <Paper className={classes.Container}>
            <div className={classes.Grid}>
                <div className={classes.DetailPanel}>
                    <DetailsPanel setNewConversion={setNewConversion} />
                </div>
                <div className={classes.BuilderPanel}>
                    <BuilderPanel newConversion={newConversion} setNewConversion={setNewConversion} />
                </div>
            </div>
        </Paper>
    );
};

export default ConversionPanel;
